import Component from '@glimmer/component';

import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import QuickFilter from 'rise-ui/components/quick-filter.gjs';
import isUnset from 'rise-ui/helpers/is-unset.js';
import one from 'rise-ui/helpers/one.js';
import { call } from 'rise-ui/utils/function.js';

export default class CompactQuickFilterComponent extends Component {
  @tracked value;

  @action initFilter(e) {
    e.stopPropagation();
    this.value = '';
  }

  @action onFilter(value) {
    this.value = value;
    call(this.args.action, null, value);
  }

  <template>
    {{#let (one @compactTitle "Quick Filter") as | title |}}
    <span class="c-compact-quick-filter">
      {{#if (isUnset this.value)}}
        <button type="button"
          class="c-compact-quick-filter__button"
          title={{title}}
          {{on "click" this.initFilter}}
        >
          {{~title~}}
        </button>
      {{else}}
        <QuickFilter
          class="c-compact-quick-filter__inputs"
          @autofocus={{true}}
          @action={{this.onFilter}}
        />
      {{/if}}
    </span>
    {{/let}}
  </template>
}
